export const environment = {
  production: true,
  apiUrl: '/api',
  tilesUrl: '/tiles',
  websocket: "/ws",
  cesiumToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI1MmQ5MzZjZi1hYThhLTQ2YTctOWQ4Mi1jYzNkMDY2NWQ3OWQiLCJpZCI6MTA0NTQzLCJpYXQiOjE2NjAyOTI4NjJ9.7xcqH5fZ_UXhO81YEvtkMDpQXoBI5QIhQn-vEhKaWXY",
  structureTTLHours: 1,
};
